import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy.component';

const seoData = {
  title: 'Privacy Policy',
  metaTags: [
    { name: 'description', content: 'description' },
    { property: 'og:title', content: 'og:title' },
    { property: 'og:description', content: 'og:description' },
    { property: 'og:url', content: 'og:description' }
  ]
};

const routes: Routes = [{ path: '', component: PrivacyPolicyComponent, data: { seo: seoData } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class PrivacyPolicyRoutingModule { }
